const RouteConstants = { 
    ROOT: '/',
    TEST: '/test',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    USERLISTING: '/userlisting',
    SPEAKERLISTING: '/speakerlisting',
    // SPEAKERVIEW: '/speaker-view',
    ADDSPEAKER: '/adduser',
    SLIDERLISTING: '/sliderlisting',
    SLIDERCREATE: '/createslider',
    EDITSPEAKER: '/editspeaker/:id',
    SESSIONFORM: '/sessionform',
    SESSIONLIST: '/sessionlist',
    VENUELIST: '/venuelist',
    VENUEFORM: '/venueform',
    VENUEEDIT: '/edit-venue/:id',
    SESSIONEDIT: '/edit-session/:id',
    ADMINLIST: '/adminlisting',
    DELEGATELIST: '/delegatelisting',
    CCAVENUE:'/ccavenue',
    DELEGATE:'/delegate-register',
    TESTDELEGATE:'/delegate-test-register',
    ATTENDEE:'/attendee-register',
    STUDENT:'/student-register',
    TERMS:'/terms-conditions',
    ABOUT:'/about',
    EDITADMIN:'/adminedit/:id',
    SUCCESS:'/success',
    ATSUCCESS:'/atsuccess',
    STUDENTLIST:'/student',
    FAILED:'/failed',
    REGISTER:'/register',
    STUDENTLISTZOHO:'/studentlist',
    DELEGATELISTZOHO: '/delegatelist',
    USERLISTINGZOHO: '/userlist',
    NEWSLISTING: '/newslist',
    CREATENEWS: '/createnews',
    EDITNEWS:'/editnews/:id',
    VIDEOLISTING: '/videoslist',
    CREATEVIDEOS: '/createvideos',
    EDITVIDEOS:'/editvideos/:id',
    PHOTOGALLERYLISTING: '/photogallerylist',
    CREATEPHOTOGALLERY: '/createphotogallery',
    EDITPHOTOGALLERY:'/editphotogallery/:id',
    // VIDEOSITELIST: '/videos',
    GALLERYSITELIST: '/photos',
    // NEWSLIST: '/news',
    NEWSVIEWSITE: '/newsviewsite/:id/:name',
    // SPEAKERLISTINGSITE: '/speakers',
    SPEAKERVIEWSITE: '/speakerview/:id/:name',
    TESTIMONIALSLISTING: '/testimonialslist',
    REPORTS: '/reports',
    CREATETESTIMONIALS: '/createtestimonials',
    EDITTESTIMONIALS: '/edittestimonials/:id',
    LISTTESTIMONIALS: '/testimonials',
    NOTFOUND:'/notfound',
    SLIDEREDIT: '/editslider/:id',
    SLIDER:'/slider',
    ATTENDEEGROUP:'/attendee-group',
    CREATEDISCOUNTCOUPON:'/creatediscountcoupon',
    LISTDISCOUNTCOUPON:'/listdiscountcoupon',
    EDITDISCOUNTCOUPON:'/editdiscountcoupon/:id',
    SGROUP: '/student-group',
    DGROUP: '/delegate-group', 
    SESSIONCATEGORYLIST:'/sessioncategorylist',
    SESSIONCATEGORYCREATE:'/sessioncategorycreate',
    SESSIONCATEGORYEDIT: '/edit-sessioncategory/:id', 
    IMAGEEDITOR:'/imageeditor',
    CREATEADMIN: '/add-admin', 
    PARTNERLOGOLIST:'/partnerlogolist',
    PARTNERLOGOCREATE:'/createpartnerlogo',
    PARTNERLOGOEDIT:'/editpartnerlogo/:id',
    SESSIONSLIST:'/sessionslist',
    PUBLICSESSIONLIST:'/sessionslist',
    SESSIONCATEGORYLIST:'/sessioncategorylist',
    SESSIONCATEGORYCREATE:'/sessioncategorycreate',
    SESSIONCATEGORYEDIT: '/edit-sessioncategory/:id',
    TERMSANDCONDITIOND: '/terms-and-condissions',
    PRIVACY:'/privacy-policy',
    FEATUREDSPEAKER:'/featuredspeaker',
    ADDFEATUREDSPEAKER:'/addfeaturedspeaker',
    FEATUREDNEWS:'/featurednews',
    ADDFEATUREDNEWS:'/addfeaturednews',
    FEATUREDPHOTOGALLERY:'/featuredphotogallery',
    ADDFEATUREDPHOTOGALLERY:'/addfeaturedphotogallery',
    FEATUREDVIDEOS:'/featuredvideos',
    ADDFEATUREDVIDEOS:'/addfeaturedvideos',
    SESSIONOLDLIST:'/session_old_list',
    WELCOME:'/welcome',
    PUSHNOTIFICATION:'/notification',
    DELEGATEFROMILFK: '/delegate-register',
    NEWSLISTILFK: '/news',
    VIDEOSLISTILFK: '/videos',
    PHOTOGALERYLISTILFK: '/photogallery-list',
    SPEAKERLISTSITEILFK: '/speaker-list',
    SPEAKERVIEWILFK: '/speaker-view/:id',
    REGISTRATIONFORM: '/registration-form',
    PAYMENT: '/payment',
    PAYMENT_SUCCESS: '/payment-success',
    PAYMENT_FAILED: '/payment-failed',
    PAYMENT_HISTORY: '/payments/history',
    PAYMENT_DETAILS: '/payments/:orderId',
    SESSIONSSITEILFK: '/sessions-list',
    LEADLOGIN: '/leadlogin',
    LEADDASH: '/delegate-login',
};
export default RouteConstants
